module.exports = __webpack_public_path__ + "static/media/11.1f100f62.jpeg";